import gql from 'graphql-tag'
import { productInfo } from './fragments.gql'

export const GET_PRODUCT_QUERY = gql`
  query GetProduct($id: ID!) {
    product: getProduct(id: $id) {
      ${productInfo}
    }
  }
`

export const MY_MENU_QUERY = gql`
  query GetMyMenu($first: Int, $skip: Int) {
    myMenu: getMyMenu(first: $first, skip: $skip) {
      ${productInfo}
    }
  }
`

export const CREATE_PRODUCT_MUTATION = gql`
  mutation CreateProduct($data: ProductCreateData!) {
    createProduct(data: $data) {
      ${productInfo}
    }
  }
`

export const UPDATE_PRODUCT_MUTATION = gql`
  mutation UpdateProduct($id: ID!, $data: ProductUpdateData!) {
    updateProduct(id: $id, data: $data) {
      ${productInfo}
    }
  }
`

export const DELETE_PRODUCT_MUTATION = gql`
  mutation DeleteProduct($id: ID!) {
    deleteProduct(id: $id) {
      ${productInfo}
    }
  }
`
